// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.inputCheckboxLabel {
  font-family: "Omnes-ATT-W02", Arial;
  font-size: 14px;
}

.errorMsg {
  margin-left: 10px;
  margin-right: 128px;
  width: 590px;
}

@media (max-width: 1024px) {
  .errorMsg {
    margin-left: 0px;
    margin-right: 0px;
  }
}
i.tooltip-icon.tooltipActive:after {
  right: 144px !important;
  top: -17px !important;
}

.tooltipContent-zte {
  left: 125px !important;
  margin-top: -46px !important;
}

.tooltipActive + div.helper-content.tooltipContent-zte {
  width: 300px !important;
  margin-left: 455px !important;
  top: 433px !important;
}
@media (max-width: 1024px) {
  .tooltipActive + div.helper-content.tooltipContent-zte {
    margin-left: 0px !important;
    top: -100px !important;
  }
}

.tooltipActive + .helper-text {
  display: block !important;
  text-align: left !important;
  width: 310px !important;
  margin-bottom: 0px !important;
  margin-left: 445px !important;
  z-index: 0;
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    margin-left: 0px;
  }
}
@media (max-width: 1024px) {
  .tooltipActive + .helper-text {
    margin-left: -75px;
  }
}

@media (max-width: 1024px) {
  .tooltipActive + .helper-content {
    margin-top: 375px !important;
    margin-left: -12px !important;
  }
}

.tooltip-input {
  right: -685px !important;
  bottom: -5px !important;
  width: 30px !important;
}
@media (max-width: 1024px) {
  .tooltip-input {
    right: -190px;
    bottom: -5px;
    width: 20px;
  }
}
@media (max-width: 980px) and (min-width: 400px) {
  .tooltip-input {
    right: -190px;
    bottom: -5px;
    width: 20px;
  }
}
@media screen and (min-device-width: 375px) and (max-device-width: 667px) {
  .tooltip-input {
    right: -170px !important;
    bottom: -5px;
    width: 20px;
  }
}
@media screen and (min-device-width: 414px) and (max-device-width: 736px) {
  .tooltip-input {
    right: -190px !important;
    bottom: -5px;
    width: 20px;
  }
}
@media (max-width: 1024px) {
  .tooltip-input {
    right: -200px;
    bottom: -5px;
    width: 20px;
  }
}

@media (max-width: 1024px) {
  .faq-tooltip-icon {
    margin-right: -10px;
  }
}
.mediaStop {
  height: 140px;
  width: 251px;
  margin-bottom: 20px;
}

.accordion {
  border-bottom: 1px solid #c4c4c4;
  margin-bottom: 60px;
}

.tab-nav {
  width: max-content;
}

.legalAgreement {
  display: flexbox;
  top: 1189px;
  left: 215px;
  width: 951px;
  height: 150px;
  background: #F2F2F2 0% 0% no-repeat padding-box;
  opacity: 1;
  font-size: 16px !important;
  padding: 15px 15px 15px 15px;
}
.legalAgreement h3 {
  margin: 0px !important;
  font-size: 24px !important;
}
.legalAgreement p {
  margin: 0px !important;
}
@media (max-width: 1024px) {
  .legalAgreement p {
    margin-left: -5px !important;
    width: 265px !important;
  }
}
@media (max-width: 1024px) {
  .legalAgreement {
    width: 325px !important;
    height: 275px;
    margin-left: -80px;
  }
}
@media only screen and (max-width: 590px) and (min-width: 420px) {
  .legalAgreement {
    width: 360px;
  }
}
@media only screen and (max-width: 1320px) and (min-width: 600px) {
  .legalAgreement {
    width: 100%;
  }
}
@media only screen and (max-width: 360px) and (min-width: 330px) {
  .legalAgreement {
    margin-left: -96px;
  }
}

.notifications-section {
  margin-top: 15px;
}
@media (max-width: 1024px) {
  .notifications-section {
    margin-left: -15px;
    width: 225px;
  }
}
@media (max-width: 1024px) {
  .notifications-section p {
    margin-left: -65px !important;
    width: 265px;
  }
}

.notifications-heading {
  font-size: 32px;
}
@media (max-width: 1024px) {
  .notifications-heading {
    font-size: 27px;
  }
}

.notifications-label {
  width: 100%;
}

#notification-email-label {
  margin-bottom: 15px;
  margin-left: 5px;
}
@media (max-width: 1024px) {
  #notification-email-label {
    margin-left: -60px;
  }
}

#notification-text-label {
  margin-left: 5px;
}
@media (max-width: 1024px) {
  #notification-text-label {
    margin-left: -60px;
  }
}

@media only screen and (min-width: 1024px) and (max-width: 1220px) {
  .tab-nav .app-tab .list a {
    font-size: 1.5rem;
  }
}
@media only screen and (min-width: 1221px) and (max-width: 1250px) {
  .tab-nav .app-tab .list a {
    font-size: 1.8rem;
  }
}
@media only screen and (min-width: 1251px) and (max-width: 1273px) {
  .tab-nav .app-tab .list a {
    font-size: 1.9rem;
  }
}
.accounts-tab {
  margin: 0 10%;
}
@media (max-width: 1024px) {
  .accounts-tab .pull-right {
    float: right;
    width: 280px;
  }
}
@media screen and (min-device-width: 375px) and (max-device-width: 667px) {
  .accounts-tab .pull-right {
    margin-right: -60px;
  }
}
@media screen and (min-device-width: 414px) and (max-device-width: 736px) {
  .accounts-tab .pull-right {
    margin-right: -30px;
  }
}
.accounts-tab .continue-button {
  max-width: 948px !important;
}
@media screen and (min-device-width: 400px) {
  .accounts-tab .mobile {
    margin-left: 30px;
  }
}
@media screen and (min-device-width: 430px) {
  .accounts-tab .mobile {
    margin-left: 0px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .btn-continue {
    float: right;
    width: 280px;
    margin-right: -35px;
  }
}
@media screen and (min-device-width: 400px) and (max-device-width: 430px) {
  .accounts-tab .btn-continue {
    margin-right: -11px !important;
  }
}
@media screen and (min-device-width: 365px) and (max-device-width: 736px) {
  .accounts-tab .btn-continue {
    margin-right: -77px;
  }
}
@media screen and (min-device-width: 320px) and (max-device-width: 360px) {
  .accounts-tab .btn-continue {
    margin-right: -70px;
  }
}
.accounts-tab .btn-link {
  padding-top: 10px;
}
@media (max-width: 1024px) {
  .accounts-tab .btn-link {
    margin-right: 60px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .text-right {
    text-align: center;
  }
}
@media only screen and (width: 393px) and (height: 852px) {
  .accounts-tab .cancel-button {
    margin-right: 15px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab h2 {
    margin-left: -75px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab p {
    margin-left: -12px;
    width: 264px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .margin-p {
    margin-left: -75px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .main-wrapper {
    margin-left: -40px !important;
  }
}
.accounts-tab h3 {
  font: 24px "Omnes-ATT-W02";
  margin-top: 30px;
  margin-bottom: 30px;
}
@media (max-width: 1024px) {
  .accounts-tab h3 {
    font: 16px "Omnes-ATT-W02-Medium";
  }
}
.accounts-tab .icon-arrows-sort-arrow {
  font-size: 17px !important;
}
.accounts-tab .search {
  position: relative;
}
.accounts-tab .search input {
  padding-right: 40px;
}
.accounts-tab .search .search-icon {
  cursor: pointer;
  margin-top: -10px;
  position: absolute;
  right: 20px;
  top: 50%;
}
.accounts-tab .search .search-icon .icon-controls-magnifyingglass {
  color: #c4c4c4;
  font-size: 25px;
  font-weight: bold;
  margin-right: 3px;
  margin-top: -2px;
}
.accounts-tab .search .search-icon .icon-close {
  color: #c4c4c4;
  font-size: 25px;
  font-weight: bold;
  margin-right: 3px;
  margin-top: -2px;
}
.accounts-tab .search #searchField::-ms-clear {
  display: none;
}
.accounts-tab .search-label {
  display: none;
}
.accounts-tab .rowdisabled {
  pointer-events: none;
}
.accounts-tab .box-outer {
  padding: 0 30px;
}
.accounts-tab .tab-content {
  padding: 0;
}
.accounts-tab .tab-content h2 {
  font-size: 3rem;
  font-weight: normal;
  margin: 30px 0;
}
.accounts-tab .tab-content p {
  margin-bottom: 20px;
}
.accounts-tab .acc-content table {
  margin: 0;
}
.accounts-tab .acc-content table tbody:last-child td {
  border-bottom: 0 !important;
}
.accounts-tab tr th:first-child {
  width: 15%;
}
.accounts-tab .accounts {
  margin-bottom: 30px;
}
.accounts-tab .buttons-section {
  padding: 30px;
}
.accounts-tab .check {
  margin-bottom: 30px;
}
.accounts-tab .check .checkbox {
  display: block;
}
.accounts-tab .error-text {
  color: hsl(0, 66%, 49%);
}
.accounts-tab .error-text .skin {
  border: 1px solid hsl(0, 66%, 49%);
}
.accounts-tab .modal-header {
  margin-bottom: 10px;
}
.accounts-tab .terms-and-conditions .checkbox a {
  color: #191919;
}
.accounts-tab .terms-and-conditions .row {
  margin-left: 0;
  margin-right: 0;
}
.accounts-tab .terms-and-conditions .form-group {
  margin-left: 0;
  margin-right: 0;
}
.accounts-tab .terms-and-conditions .terms h1 {
  margin-top: 30px;
}
.accounts-tab .agreement {
  margin-top: 15px;
}
.accounts-tab .agreement h2 {
  font-size: 20px;
}
.accounts-tab .agreement .attTerms {
  padding-bottom: 10px;
}
.accounts-tab .agreement p {
  margin-bottom: 0;
  display: inline;
}
.accounts-tab .agreement .termsServiceText p {
  margin-bottom: 0;
  display: inline;
}
.accounts-tab .signupwithnotab .agreement {
  border-top: 1px solid #d2d2d2;
  margin-top: 30px;
}
.accounts-tab .signupwithnotab .agreement h3 {
  margin-bottom: 20px;
}
.accounts-tab .signuptabcontainer {
  position: relative;
}
.accounts-tab .signuptabcontainer .pagination::after {
  border: 0 none;
  height: 0;
  width: 0;
}
.accounts-tab .alert {
  margin-bottom: 30px;
}
.accounts-tab .fan-profile {
  cursor: pointer;
}
.accounts-tab .terms-of-service-container {
  border-top: 1px solid #d2d2d2;
}
.accounts-tab .terms-of-service-container .checkbox:first-child {
  margin-bottom: 20px;
}
.accounts-tab .ineligible-fans {
  color: hsl(0, 66%, 49%);
}
.accounts-tab .attTerms,
.accounts-tab .ibmTerms {
  margin-bottom: 20px;
  font-size: 16px;
  font-family: Omnes-ATT-W02, Arial;
}
@media (max-width: 1024px) {
  .accounts-tab {
    margin: 0 80px;
  }
  .accounts-tab .accordion {
    margin-bottom: 30px;
  }
  .accounts-tab .tab-nav {
    width: unset;
  }
  .accounts-tab .signup-section .tabContainer {
    height: max-content;
  }
  .accounts-tab .btn-cancel {
    text-align: center;
  }
}
@media screen and (max-width: 1024px) and (min-device-width: 400px) and (max-device-width: 600px) {
  .accounts-tab .btn-cancel {
    margin-left: 68px !important;
  }
}
@media screen and (max-width: 1024px) and (min-device-width: 360px) and (max-device-width: 390px) {
  .accounts-tab .btn-cancel {
    margin-left: 26px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .btn {
    text-align: center;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .tab-nav .app-tab .list > a {
    padding: 25px 1px !important;
    color: #191919 !important;
  }
  .accounts-tab .tab-content h2,
  .accounts-tab .tab-content p {
    margin-bottom: 20px !important;
  }
  .accounts-tab .accounts,
  .accounts-tab .check {
    margin-bottom: 20px;
  }
  .accounts-tab .form-group {
    margin-bottom: 20px;
  }
  .accounts-tab .agreement p {
    margin-bottom: 0 !important;
  }
  .accounts-tab .grid-table {
    margin-left: -15px;
    margin-right: -15px;
  }
}
@media (max-width: 1024px) and (max-width: 1024px) {
  .accounts-tab .grid-table {
    margin-left: -100px;
    margin-right: -39px;
  }
}
@media (max-width: 1024px) {
  .accounts-tab .step-indicator,
  .accounts-tab .alert {
    margin-bottom: 30px !important;
    margin-left: -75px;
  }
}
.accounts-tab .search-field {
  float: right;
}
.accounts-tab .link-to-brief {
  margin: 20px 0;
}

.msg-box1 {
  top: 577px;
  left: 421px;
  width: 598px;
  margin-left: 5px !important;
  background: #F1F2F3 0% 0% no-repeat padding-box;
  opacity: 1;
  padding: 30px;
  margin-top: 20px;
  margin-bottom: 30px;
  margin-left: -12px;
  font-family: Regular 12px/21px ATTAleckSans-Regular !important;
}
.msg-box1 p {
  margin-bottom: 5px;
}
@media (max-width: 1024px) {
  .msg-box1 {
    font-family: Regular 12px/21px ATTAleckSans-Regular !important;
    margin-top: -45px;
    width: 321px;
    margin-left: -25px !important;
  }
  .msg-box1 p {
    margin-bottom: 5px;
    margin-top: 5px;
  }
}
@media only screen and (max-width: 700px) and (min-width: 920px) {
  .msg-box1 {
    width: 325px !important;
  }
}
@media only screen and (max-width: 1220px) and (min-width: 1020px) {
  .msg-box1 {
    width: 445px;
  }
}

.new-tooltips {
  font-size: 17px !important;
  color: var(--Controls-Tooltip-icon, #454B52) !important;
  top: 550px !important;
  margin-right: 100px;
}
@media (max-width: 1024px) {
  .new-tooltips {
    top: 481px !important;
    margin-right: 52px;
  }
}

.new-tooltip-input {
  right: -500px;
  bottom: -10px;
  width: 32px;
}

.toggle-switch {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin-left: 25px;
}

.toggle-switch input[type=checkbox] {
  display: none;
}

.toggle-switch .slider {
  position: relative;
  width: 40px;
  height: 20px;
  background-color: #ccc;
  border-radius: 20px;
  transition: background-color 0.3s;
  opacity: 1;
}

.toggle-switch .slider:before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  background-color: white;
  border-radius: 50%;
  top: 2px;
  left: 2px;
  transition: transform 0.3s;
}

.toggle-switch input[type=checkbox]:disabled + .slider {
  opacity: 0.3;
}

.toggle-switch input[type=checkbox]:checked + .slider {
  background: var(--Color-Functional-Functional-blue, #0074B3);
}

.toggle-switch input[type=checkbox]:checked + .slider:before {
  transform: translateX(20px);
}

.toggle-switch span {
  margin-left: 10px;
}

.button-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-btn {
  margin-right: auto;
}

.pull-right {
  margin-left: auto;
}

.continue-btn {
  border-radius: 42px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  background: var(--Controls-Button-Primary-Fill, #00388F);
}
@media (max-width: 1024px) {
  .continue-btn {
    width: 100px !important;
    margin-right: 10px !important;
  }
}

.back-btn {
  min-width: 100px;
  height: 32px;
  opacity: 1;
  gap: 10px;
  border-radius: 48px;
  border-width: 2px;
  padding-top: 8px;
  padding-right: 24px;
  padding-bottom: 8px;
  padding-left: 24px;
  border: 2px solid var(--Controls-Button-Secondary-Border, #00388F);
  background: #F1F2F3 0% 0% no-repeat padding-box !important;
  color: var(--Controls-Button-Secondary-Text-icon, #00388F);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
}

.tooltip-content {
  width: 300;
  height: 67.0001296997;
  angle: 0 deg;
  opacity: 1;
  border-width: 1px;
  border-radius: 4px;
  color: black;
  top: 441px !important;
  height: 66px;
  background: var(--Controls-Fill, #FFFFFF);
  box-shadow: 0px 2px 12px 0px rgba(37, 48, 58, 0.0588235294);
  box-shadow: 0px 2px 4px -1px rgba(37, 48, 58, 0.0588235294);
  box-shadow: 0px 2px 8px 0px rgba(37, 48, 58, 0.1215686275);
}
@media (max-width: 1024px) {
  .tooltip-content {
    top: 30px !important;
  }
}

i.tooltip-icon.tooltipActive:after {
  background-color: var(--Controls-Fill, #FFFFFF);
  left: 0px;
}

.tooltip-zte {
  top: 461px !important;
  margin-right: 99px !important;
}
@media (max-width: 1024px) {
  .tooltip-zte {
    top: 352px !important;
    margin-right: 50px !important;
  }
}

.tooltip-kme {
  top: 551px !important;
  margin-right: 99px !important;
}
@media (max-width: 1024px) {
  .tooltip-kme {
    top: 352px !important;
    margin-right: 50px !important;
  }
}

.tooltipActive + div.helper-content.tooltipContent-kme {
  width: 300px !important;
  margin-left: 455px !important;
  top: 444px !important;
}
@media (max-width: 1024px) {
  .tooltipActive + div.helper-content.tooltipContent-kme {
    margin-left: 0px !important;
    top: -100px !important;
  }
}

@media (max-width: 1024px) {
  .fan-selection {
    margin-left: -25px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/signup-setup/enrollment-signup-setup/enrollment-signup-setup.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACI,mCAAA;EACE,eAAA;AAmJN;;AA1IA;EACI,iBAAA;EACA,mBAAA;EACA,YAAA;AA6IJ;;AFrII;EELA;IACI,gBAAA;IACA,iBAAA;EA8IN;AACF;AA3IA;EACI,uBAAA;EACA,qBAAA;AA6IJ;;AA1IA;EACI,sBAAA;EACA,4BAAA;AA6IJ;;AApIA;EAKI,uBAAA;EACA,6BAAA;EACA,qBAAA;AAmIJ;AF3JI;EEiBJ;IAEO,2BAAA;IACA,sBAAA;EA4IL;AACF;;AAtIA;EACI,yBAAA;EACA,2BAAA;EACA,uBAAA;EACA,6BAAA;EACA,6BAAA;EACA,UAAA;AAyIJ;AF1KI;EE2BJ;IASQ,gBAAA;EA0IN;AACF;AAvII;EAbJ;IAeQ,kBAAA;EAyIN;AACF;;AFpLI;EE8CJ;IAEQ,4BAAA;IACA,6BAAA;EAyIN;AACF;;AArIA;EACI,wBAAA;EACA,uBAAA;EACA,sBAAA;AAwIJ;AFjMI;EEsDJ;IAMQ,aAAA;IACA,YAAA;IACA,WAAA;EAyIN;AACF;AAxII;EAVJ;IAWQ,aAAA;IACA,YAAA;IACA,WAAA;EA2IN;AACF;AA1II;EAfJ;IAgBQ,wBAAA;IACA,YAAA;IACA,WAAA;EA6IN;AACF;AA5IM;EApBN;IAqBQ,wBAAA;IACA,YAAA;IACA,WAAA;EA+IN;AACF;AA9IM;EAzBN;IA0BQ,aAAA;IACA,YAAA;IACA,WAAA;EAiJN;AACF;;AA5IA;EACA;IACI,mBAAA;EA+IF;AACF;AA5IA;EACI,aAAA;EACA,YAAA;EACA,mBAAA;AA8IJ;;AA5IA;EACQ,gCAAA;EACA,mBAAA;AA+IR;;AA5IA;EAEI,kBAAA;AA8IJ;;AA3IA;EACI,gBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,+CAAA;EACA,UAAA;EAEA,0BAAA;EACA,4BAAA;AA6IJ;AA5II;EACI,sBAAA;EACA,0BAAA;AA8IR;AA3II;EACI,sBAAA;AA6IR;AF3QI;EE6HA;IAGQ,4BAAA;IACA,uBAAA;EA+IV;AACF;AFjRI;EE6GJ;IAyBQ,uBAAA;IACA,aAAA;IACA,kBAAA;EA+IN;AACF;AA9IM;EA7BN;IA+Be,YAAA;EAgJb;AACF;AA/IO;EAjCP;IAmCc,WAAA;EAiJZ;AACF;AAhJO;EArCP;IAuCY,kBAAA;EAkJV;AACF;;AA/IA;EACI,gBAAA;AAkJJ;AF3SI;EEwJJ;IAGO,kBAAA;IACA,YAAA;EAoJL;AACF;AFjTI;EE8JA;IAEI,6BAAA;IACA,YAAA;EAqJN;AACF;;AAjJA;EACI,eAAA;AAoJJ;AAnJI;EAFJ;IAGQ,eAAA;EAsJN;AACF;;AAnJA;EACI,WAAA;AAsJJ;;AAnJA;EACI,mBAAA;EACA,gBAAA;AAsJJ;AFzUI;EEiLJ;IAIQ,kBAAA;EAwJN;AACF;;AAtJA;EACI,gBAAA;AAyJJ;AFlVI;EEwLJ;IAGQ,kBAAA;EA2JN;AACF;;AAxJA;EAIU;IACE,iBAAA;EAwJV;AACF;AAnJA;EAIQ;IACE,iBAAA;EAkJR;AACF;AA7IA;EAIQ;IACE,iBAAA;EA4IR;AACF;AAnIA;EACI,aAAA;AAqIJ;AF1WI;EEsOA;IAEI,YAAA;IACA,YAAA;EAsIN;AACF;AApIQ;EANJ;IAOK,mBAAA;EAuIP;AACF;AAtIO;EATH;IAUI,mBAAA;EAyIN;AACF;AAtII;EACI,2BAAA;AAwIR;AApIQ;EADJ;IAEQ,iBAAA;EAuIV;AACF;AAtIQ;EAJJ;IAKQ,gBAAA;EAyIV;AACF;AFvYI;EEgQA;IAEQ,YAAA;IACA,YAAA;IACA,mBAAA;EAyIV;AACF;AAxIY;EANR;IAOY,8BAAA;EA2Id;AACF;AA1IY;EATR;IAUU,mBAAA;EA6IZ;AACF;AA5IY;EAZR;IAaY,mBAAA;EA+Id;AACF;AAhII;EACI,iBAAA;AAkIR;AFhaI;EE6RA;IAGM,kBAAA;EAoIR;AACF;AFraI;EEmSA;IAEI,kBAAA;EAoIN;AACF;AAjIQ;EADJ;IAEQ,kBAAA;EAoIV;AACF;AF/aI;EEuTJ;IAEQ,kBAAA;EA0HN;AACF;AFpbI;EE4TJ;IAEI,kBAAA;IACA,YAAA;EA0HF;AACF;AF1bI;EEkUJ;IAEI,kBAAA;EA0HF;AACF;AF/bI;EEuUJ;IAEQ,6BAAA;EA0HN;AACF;AAvHE;EACE,0BAAA;EACA,gBAAA;EACA,mBAAA;AAyHJ;AFzcI;EE6UF;IAKI,iCAAA;EA2HJ;AACF;AAzHE;EACM,0BAAA;AA2HR;AAzHI;EACI,kBAAA;AA2HR;AA1HQ;EACI,mBAAA;AA4HZ;AA1HQ;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AA4HZ;AA3HY;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AA6HhB;AA3HY;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AA6HhB;AA1HI;EACE,aAAA;AA4HN;AAxHE;EACE,aAAA;AA0HJ;AAvHI;EACI,oBAAA;AAyHR;AAvHI;EACI,eAAA;AAyHR;AAvHI;EACI,UAAA;AAyHR;AAxHQ;EACI,eAAA;EACA,mBAAA;EACA,cAAA;AA0HZ;AAxHQ;EACI,mBAAA;AA0HZ;AAtHQ;EACI,SAAA;AAwHZ;AAvHY;EACI,2BAAA;AAyHhB;AAnHY;EACI,UAAA;AAqHhB;AAjHI;EACI,mBAAA;AAmHR;AAjHI;EAGI,aAAA;AAiHR;AA/GI;EACI,mBAAA;AAiHR;AAhHQ;EACI,cAAA;AAkHZ;AA/GI;EACI,uBAAA;AAiHR;AAhHQ;EACI,kCAAA;AAkHZ;AA/GI;EACI,mBAAA;AAiHR;AA7GY;EACI,cAAA;AA+GhB;AA5GQ;EACI,cAAA;EACA,eAAA;AA8GZ;AA5GQ;EACI,cAAA;EACA,eAAA;AA8GZ;AA3GY;EACI,gBAAA;AA6GhB;AAzGI;EAEI,gBAAA;AA0GR;AAzGQ;EACI,eAAA;AA2GZ;AAzGU;EACE,oBAAA;AA2GZ;AAtGQ;EACI,gBAAA;EACA,eAAA;AAwGZ;AArGY;EACI,gBAAA;EACA,eAAA;AAuGhB;AAlGQ;EACI,6BAAA;EACA,gBAAA;AAoGZ;AAnGY;EACI,mBAAA;AAqGhB;AAjGI;EACI,kBAAA;AAmGR;AAjGY;EACI,cAAA;EACA,SAAA;EACA,QAAA;AAmGhB;AA/FI;EACI,mBAAA;AAiGR;AA/FI;EACI,eAAA;AAiGR;AA/FI;EACI,6BAAA;AAiGR;AA/FY;EACI,mBAAA;AAiGhB;AA7FI;EACI,uBAAA;AA+FR;AA7FI;;EAEI,mBAAA;EACA,eAAA;EACA,iCAAA;AA+FR;AFpmBI;EEoOJ;IAoSQ,cAAA;EAgGN;EA9FE;IACI,mBAAA;EAgGN;EA9FC;IACE,YAAA;EAgGH;EA7FI;IACE,mBAAA;EA+FN;EA3FM;IAEI,kBAAA;EA4FV;AACF;AA3FY;EAJJ;IAKQ,4BAAA;EA8Fd;AACF;AA9FgB;EANR;IAOQ,iBAAA;EAiGd;AACF;AF/nBI;EEoiBI;IACI,kBAAA;EA8FV;AACF;AFpoBI;EE8iBY;IACI,4BAAA;IACA,yBAAA;EAyFlB;EApFU;;IAEI,8BAAA;EAsFd;EAnFM;;IAEI,mBAAA;EAqFV;EAnFM;IACI,mBAAA;EAqFV;EAlFU;IACI,2BAAA;EAoFd;EAjFM;IACI,kBAAA;IACA,mBAAA;EAmFV;AACF;AF5pBI;EEskBI;IAII,mBAAA;IACA,mBAAA;EAsFV;AACF;AFlqBI;EE8kBI;;IAEI,8BAAA;IACA,kBAAA;EAuFV;AACF;AArFI;EACI,YAAA;AAuFR;AApFI;EACI,cAAA;AAsFR;;AAlFA;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EAEA,+CAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8DAAA;AAoFJ;AAlFI;EACE,kBAAA;AAoFN;AFhsBI;EE6lBJ;IAmBM,8DAAA;IACA,iBAAA;IACA,YAAA;IAEA,6BAAA;EAmFJ;EAlFI;IACE,kBAAA;IACA,eAAA;EAoFN;AACF;AAlFI;EA7BJ;IA+BM,uBAAA;EAoFJ;AACF;AAnFI;EAjCJ;IAmCM,YAAA;EAqFJ;AACF;;AAlFE;EACE,0BAAA;EACA,uDAAA;EACA,qBAAA;EACA,mBAAA;AAqFJ;AF7tBI;EEooBF;IAMM,qBAAA;IACA,kBAAA;EAuFN;AACF;;AApFE;EACE,aAAA;EACA,aAAA;EACA,WAAA;AAuFJ;;AAnFE;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAsFJ;;AAnFE;EACE,aAAA;AAsFJ;;AAnFE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,iCAAA;EACA,UAAA;AAsFJ;;AAnFE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,0BAAA;AAsFJ;;AAnFE;EACE,YAAA;AAsFJ;;AAnFE;EACE,4DAAA;AAsFJ;;AAnFE;EACE,2BAAA;AAsFJ;;AAnFE;EACE,iBAAA;AAsFJ;;AAnFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAsFJ;;AAlFE;EACE,kBAAA;AAqFJ;;AAlFE;EACE,iBAAA;AAqFJ;;AAlFE;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,wDAAA;AAqFJ;AFlzBI;EEstBF;IASI,uBAAA;IACA,6BAAA;EAuFJ;AACF;;AApFE;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kEAAA;EACA,0DAAA;EACA,0DAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAuFJ;;AApFE;EACE,UAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,yCAAA;EACA,2DAAA;EACA,2DAAA;EACA,0DAAA;AAuFJ;AF51BI;EEwvBF;IAeM,oBAAA;EAyFN;AACF;;AAtFE;EACE,+CAAA;EACA,SAAA;AAyFJ;;AAtFA;EACI,qBAAA;EACA,6BAAA;AAyFJ;AF32BI;EEgxBJ;IAIQ,qBAAA;IACA,6BAAA;EA2FN;AACF;;AAxFA;EAEI,qBAAA;EACA,6BAAA;AA0FJ;AFt3BI;EEyxBJ;IAKQ,qBAAA;IACA,6BAAA;EA4FN;AACF;;AAzFA;EACI,uBAAA;EACA,6BAAA;EAEA,qBAAA;AA2FJ;AFl4BI;EEmyBJ;IAMQ,2BAAA;IACA,sBAAA;EA6FN;AACF;;AFx4BI;EEizBA;IACI,kBAAA;EA2FN;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.inputCheckboxLabel{\n    font-family: 'Omnes-ATT-W02', Arial;\n      font-size: 14px;\n  }\n  \n.acc-content {\n    // padding-bottom: 5px;\n    // // padding-left: 20px;\n    // margin-bottom: 8px;\n}\n\n.errorMsg{\n    margin-left: 10px;\n    margin-right: 128px;\n    width: 590px;\n}\n@include respond-to('small') {\n    .errorMsg{\n        margin-left: 0px;\n        margin-right: 0px;\n    }\n}\n\ni.tooltip-icon.tooltipActive:after {\n    right: 144px !important;\n    top: -17px !important;\n}\n\n.tooltipContent-zte {\n    left: 125px !important;\n    margin-top: -46px !important;\n    // color: black;\n}\n\n// .tooltipActive + .tooltipContent-zte {\n//     width: 300px !important;\n//     margin-left: 120px !important;\n// }\n\n.tooltipActive + div.helper-content.tooltipContent-zte {\n    @include respond-to('small') {\n       margin-left: 0px !important;\n       top: -100px !important;\n    }\n    width: 300px !important;\n    margin-left: 455px !important;\n    top: 433px !important;\n}\n\n.tooltipActive + .helper-text {\n    display: block !important;\n    text-align: left !important;\n    width: 310px !important;\n    margin-bottom: 0px !important;\n    margin-left: 445px !important;\n    z-index: 0;\n    @include respond-to('small') {\n        // width: 120px !important;\n        margin-left: 0px;\n        // height: 290px;\n    }\n\n    @media(max-width: 1024px) {\n        // width: 700% !important;\n        margin-left: -75px;\n    }\n}\n\n.tooltipActive + .helper-content {\n    @include respond-to('small') {\n        margin-top: 375px !important;\n        margin-left: -12px !important;\n    }\n}\n\n\n.tooltip-input {\n    right: -685px !important;\n    bottom: -5px !important;\n    width: 30px !important;\n\n    @include respond-to('small') {\n        right: -190px;\n        bottom: -5px;\n        width: 20px;\n    }\n    @media(max-width: 980px) and (min-width:400px) {\n        right: -190px ;\n        bottom: -5px;\n        width: 20px;\n    }\n    @media screen and (min-device-width : 375px) and (max-device-width : 667px) {\n        right: -170px !important;\n        bottom: -5px;\n        width: 20px;\n      }\n      @media screen and (min-device-width : 414px) and (max-device-width : 736px) {\n        right: -190px !important;\n        bottom: -5px;\n        width: 20px;\n      }\n      @media(max-width: 1024px) {\n        right: -200px ;\n        bottom: -5px;\n        width: 20px;\n      }\n     \n}\n\n\n@media(max-width: 1024px) {\n.faq-tooltip-icon {\n    margin-right: -10px;\n}\n}\n\n.mediaStop{\n    height:140px;\n    width:251px;\n    margin-bottom: 20px;\n    }\n.accordion {\n        border-bottom: 1px solid color(default, darker);\n        margin-bottom: 60px;\n    }\n\n.tab-nav {\n    \n    width: max-content ;\n  }\n\n.legalAgreement {\n    display: flexbox;\n    top: 1189px;\n    left: 215px;\n    width: 951px ;\n    height: 150px;\n    background: #F2F2F2 0% 0% no-repeat padding-box;\n    opacity: 1;\n    //padding: 25px;\n    font-size: 16px !important;\n    padding: 15px 15px 15px 15px;\n    h3 {\n        margin: 0px  !important;\n        font-size: 24px !important;\n    }\n\n    p {\n        margin: 0px !important;\n        @include respond-to ('small') {\n            margin-left: -5px !important;\n            width: 265px !important;\n        }\n    }\n\n    @include respond-to ('small') {\n        width: 325px !important ;\n        height: 275px;\n        margin-left: -80px;\n    }\n      @media only screen and\n           (max-width: 590px) and (min-width:420px) {\n               width: 360px ;\n        }\n       @media only screen and\n          (max-width: 1320px) and (min-width:600px) {\n              width: 100% ;\n       }\n       @media only screen and \n       (max-width: 360px) and (min-width:330px) {\n            margin-left: -96px;\n       }\n}\n\n.notifications-section {\n    margin-top: 15px;\n    @include respond-to ('small') {\n       margin-left: -15px;\n       width: 225px;\n    }\n    p{\n        @include respond-to ('small') {\n        margin-left: -65px !important;\n        width: 265px;\n        }\n    }\n}\n\n.notifications-heading {\n    font-size: 32px;\n    @media(max-width: 1024px) {\n        font-size: 27px;\n    }\n}\n\n.notifications-label {\n    width: 100%;\n}\n\n#notification-email-label {\n    margin-bottom: 15px;\n    margin-left: 5px;\n    @include respond-to('small'){\n        margin-left: -60px;  \n    }\n}\n#notification-text-label {\n    margin-left: 5px;\n    @include respond-to('small'){\n        margin-left: -60px;  \n    }\n}\n\n@media only screen and (min-width:1024px) and (max-width: 1220px){\n    .tab-nav{\n      .app-tab{\n        .list{\n          a{\n            font-size:1.5rem;\n          }\n        }\n      }\n    }\n}\n@media only screen and (min-width:1221px) and (max-width: 1250px){\n  .tab-nav{\n    .app-tab{\n      .list{\n        a{\n          font-size:1.8rem;\n        }\n      }\n    }\n  }\n}\n@media only screen and (min-width:1251px) and (max-width: 1273px){\n  .tab-nav{\n    .app-tab{\n      .list{\n        a{\n          font-size:1.9rem;\n        }\n      }\n    }\n  }\n}\n  \n.page-count{\n}\n\n.accounts-tab {\n    margin: 0 10%;\n    .pull-right {\n        @include respond-to('small'){\n        float: right;\n        width: 280px ;\n        // margin-right: -60px ;\n        }\n        @media screen and (min-device-width : 375px) and (max-device-width : 667px) {\n         margin-right: -60px;\n       }\n       @media screen and (min-device-width : 414px) and (max-device-width : 736px) {\n        margin-right: -30px;\n      }\n    }\n\n    .continue-button{\n        max-width: 948px !important;\n    }\n    \n    .mobile{\n        @media screen and (min-device-width : 400px){\n            margin-left: 30px;\n        }\n        @media screen and (min-device-width : 430px){\n            margin-left: 0px;\n        }\n    }\n    .btn-continue {\n        @include respond-to('small'){\n            float: right;\n            width: 280px ;\n            margin-right: -35px ;\n            }\n            @media screen and (min-device-width : 400px) and (max-device-width : 430px) {\n                margin-right: -11px !important;\n            }\n            @media screen and (min-device-width : 365px) and (max-device-width : 736px) {\n              margin-right: -77px;\n            }\n            @media screen and (min-device-width : 320px) and (max-device-width : 360px) {\n                margin-right: -70px;\n              }\n    //     @include respond-to('small'){\n    //     float: right;\n    //     width: 280px ;\n    //     margin-right: -35px ;\n\n    //     @media screen and (min-device-width : 375px) and (max-device-width : 667px) {\n    //         margin-right: -60px;\n    //       }\n    //       @media screen and (min-device-width : 414px) and (max-device-width : 736px) {\n    //        margin-right: -30px;\n    //      }\n    // }\n    }\n\n    .btn-link {\n        padding-top: 10px;\n        @include respond-to('small'){\n          margin-right: 60px;\n        }\n    }\n    .text-right {\n        @include respond-to('small'){\n        text-align: center;\n        }\n    }\n    .cancel-button {\n        @media only screen and (width: 393px) and (height: 852px)  {\n            margin-right: 15px;\n        }\n    }\n  // @media only screen and (max-width: 1280px) {\n  //   margin: 0 18%;\n  // }\n  \n  // @media only screen and (min-width: 1281px) and (max-width: 1366px) {\n  //   margin: 0 20%;\n  // }\n//   .acc-content {\n//       margin-bottom: 30px;\n//   }\nh2{\n    @include respond-to (small){\n        margin-left: -75px;\n      }  \n}\np{\n    @include respond-to (small){\n    margin-left: -12px ;\n    width: 264px;\n    }\n}\n.margin-p {\n    @include respond-to (small){\n    margin-left: -75px;\n    }\n}\n.main-wrapper{\n    @include respond-to (small){\n        margin-left: -40px !important;\n        } \n}\n\n  h3 {\n    font: 24px 'Omnes-ATT-W02';\n    margin-top: 30px;\n    margin-bottom: 30px;\n    @include respond-to (small){\n      font: 16px 'Omnes-ATT-W02-Medium';\n    }\n  }\n  .icon-arrows-sort-arrow{\n        font-size: 17px !important;\n    }\n    .search {\n        position: relative;\n        input {\n            padding-right: 40px;\n        }\n        .search-icon {\n            cursor: pointer;\n            margin-top: -10px;\n            position: absolute;\n            right: 20px;\n            top: 50%;\n            .icon-controls-magnifyingglass {\n                color: color(default, darker);\n                font-size: 25px;\n                font-weight: bold;\n                margin-right: 3px;\n                margin-top: -2px;\n            }\n            .icon-close {\n                color: color(default, darker);\n                font-size: 25px;\n                font-weight: bold;\n                margin-right: 3px;\n                margin-top: -2px;\n              }\n        }\n    #searchField::-ms-clear{\n      display:none;\n    }\n    }\n\n  .search-label{\n    display: none;\n  }\n\n    .rowdisabled {\n        pointer-events: none;\n    }\n    .box-outer {\n        padding: 0 30px;\n    }\n    .tab-content {\n        padding: 0;\n        h2 {\n            font-size: 3rem;\n            font-weight: normal;\n            margin: 30px 0;\n        }\n        p {\n            margin-bottom: 20px;\n        }\n    }\n    .acc-content {\n        table {\n            margin: 0;\n            tbody:last-child td {\n                border-bottom: 0 !important;\n            }\n        }\n    }\n    tr {\n        th {\n            &:first-child {\n                width: 15%;\n            }\n        }\n    }\n    .accounts {\n        margin-bottom: 30px;\n    }\n    .buttons-section {\n        //margin-top: 20px;\n        //border-top: 1px solid color(default, dark);\n        padding: 30px;\n    }\n    .check {\n        margin-bottom: 30px;\n        .checkbox {\n            display: block;\n        }\n    }\n    .error-text {\n        color: color(danger, base);\n        .skin {\n            border: 1px solid color(danger, base);\n        }\n    }\n    .modal-header {\n        margin-bottom: 10px;\n    }\n    .terms-and-conditions {\n        .checkbox {\n            a {\n                color: color(inverse, darker)\n            }\n        }\n        .row {\n            margin-left: 0;\n            margin-right: 0;\n        }\n        .form-group {\n            margin-left: 0;\n            margin-right: 0;\n        }\n        .terms {\n            h1 {\n                margin-top: 30px;\n            }\n        }\n    }\n    .agreement {\n        //border-top: 1px solid color(default, dark);\n        margin-top: 15px; // padding: 30px 0 20px;\n        h2{\n            font-size: 20px;\n          }\n          .attTerms{\n            padding-bottom:10px;\n          }\n        //   .awaitAttTerms{\n        //     color: #5a5a5a;\n        //   }\n        p {\n            margin-bottom: 0;\n            display:inline;\n        }\n        .termsServiceText{\n            p {\n                margin-bottom: 0;\n                display:inline;\n            }\n        }\n    }\n    .signupwithnotab {\n        .agreement {\n            border-top: 1px solid color(default, dark);\n            margin-top: 30px;\n            h3 {\n                margin-bottom: 20px;\n            }\n        }\n    }\n    .signuptabcontainer {\n        position: relative;\n        .pagination {\n            &::after {\n                border: 0 none;\n                height: 0;\n                width: 0;\n            }\n        }\n    }\n    .alert {\n        margin-bottom: 30px;\n    }\n    .fan-profile {\n        cursor: pointer;\n    }\n    .terms-of-service-container {\n        border-top: 1px solid #d2d2d2;\n        .checkbox {\n            &:first-child {\n                margin-bottom: 20px;\n            }\n        }\n    }\n    .ineligible-fans {\n        color: color(danger, base);\n    }\n    .attTerms,\n    .ibmTerms {\n        margin-bottom: 20px;\n        font-size: 16px;\n        font-family: Omnes-ATT-W02,Arial;\n    }\n    @include respond-to (small) {\n        margin: 0 80px;\n\n    .accordion {\n        margin-bottom: 30px;\n    }\n   .tab-nav{\n     width:unset;\n    }\n    .signup-section{\n      .tabContainer{\n        height:max-content;\n      }\n    }\n   \n        .btn-cancel {\n            //margin: 20px 0;\n            text-align: center;\n            //width: 100%;\n            @media screen and (min-device-width : 400px)and (max-device-width : 600px){\n                margin-left: 68px !important;}\n                @media screen and (min-device-width : 360px) and (max-device-width : 390px) {\n                margin-left: 26px;\n            }\n            // @include respond-to('small'){\n            //     margin-left: 32px !important;\n            // }\n\n        }\n        .btn {\n            text-align: center;\n           // width: 100%;\n            @include respond-to('small'){\n                //width: 325px;\n                //margin-right: 90px;\n            }\n        }\n        .tab-nav {\n            .app-tab {\n                .list>a {\n                    padding: 25px 1px !important;\n                    color: #191919 !important;\n                }\n            }\n        }\n        .tab-content {\n            h2,\n            p {\n                margin-bottom: 20px !important;\n            }\n        }\n        .accounts,\n        .check {\n            margin-bottom: 20px;\n        }\n        .form-group {\n            margin-bottom: 20px;\n        }\n        .agreement {\n            p {\n                margin-bottom: 0 !important;\n            }\n        }\n        .grid-table {\n            margin-left: -15px;\n            margin-right: -15px;\n            @include respond-to(small){\n            margin-left: -100px;\n            margin-right: -39px;\n            }\n        }\n        .step-indicator,\n        .alert {\n            margin-bottom: 30px !important;\n            margin-left: -75px;\n        }\n    }\n    .search-field{\n        float: right;\n      }\n    \n    .link-to-brief {\n        margin: 20px 0;\n    }\n}\n\n.msg-box1 {\n    top: 577px;\n    left: 421px;\n    width: 598px;\n    margin-left: 5px !important;\n    // height: 475px;\n    background: #F1F2F3 0% 0% no-repeat padding-box;\n    opacity: 1;\n    padding: 30px;\n    margin-top: 20px;\n    margin-bottom: 30px;\n    margin-left: -12px;\n    font-family: Regular 12px/21px ATTAleckSans-Regular !important;\n  \n    p{\n      margin-bottom: 5px;\n    //   margin-top: 5px;\n    }\n    @include respond-to (small) {\n      font-family: Regular 12px/21px ATTAleckSans-Regular !important;\n      margin-top: -45px;\n      width: 321px;\n    //   height: 500px;\n      margin-left: -25px !important;\n      p{\n        margin-bottom: 5px;\n        margin-top: 5px;\n      }\n    }\n    @media only screen and\n     (max-width: 700px) and (min-width:920px) {\n      width: 325px !important;\n       }\n    @media only screen and\n     (max-width: 1220px) and (min-width:1020px) {\n      width: 445px;\n       }\n  }\n\n  .new-tooltips {\n    font-size: 17px !important;\n    color: var(--Controls-Tooltip-icon, #454B52) !important;\n    top: 550px !important;\n    margin-right: 100px;\n    @include respond-to('small') {\n        top: 481px !important;\n        margin-right: 52px;\n    }\n  }\n\n  .new-tooltip-input {\n    right: -500px;\n    bottom: -10px;\n    width: 32px;\n  }\n\n\n  .toggle-switch {\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n    margin-left: 25px;\n  }\n  \n  .toggle-switch input[type=\"checkbox\"] {\n    display: none;\n  }\n  \n  .toggle-switch .slider {\n    position: relative;\n    width: 40px;\n    height: 20px;\n    background-color: #ccc;\n    border-radius: 20px;\n    transition: background-color 0.3s;\n    opacity: 1;\n  }\n  \n  .toggle-switch .slider:before {\n    content: \"\";\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    background-color: white;\n    border-radius: 50%;\n    top: 2px;\n    left: 2px;\n    transition: transform 0.3s;\n  }\n\n  .toggle-switch input[type=checkbox]:disabled + .slider {\n    opacity: 0.3;\n  }\n  \n  .toggle-switch input[type=\"checkbox\"]:checked + .slider {\n    background: var(--Color-Functional-Functional-blue, #0074B3);\n  }\n  \n  .toggle-switch input[type=\"checkbox\"]:checked + .slider:before {\n    transform: translateX(20px);\n  }\n  \n  .toggle-switch span {\n    margin-left: 10px;\n  }\n\n  .button-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    \n  }\n  \n  .back-btn {\n    margin-right: auto;\n  }\n  \n  .pull-right {\n    margin-left: auto;\n  }\n\n  .continue-btn {\n    border-radius: 42px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 15px;\n    background: var(--Controls-Button-Primary-Fill, #00388F);\n    @include respond-to('small') {\n      width: 100px !important;\n      margin-right: 10px !important;\n    }\n  }\n\n  .back-btn {\n    min-width: 100px;\n    height: 32px;\n    opacity: 1;\n    gap: 10px;\n    border-radius: 48px;\n    border-width: 2px;\n    padding-top: 8px;\n    padding-right: 24px;\n    padding-bottom: 8px;\n    padding-left: 24px;\n    border: 2px solid var(--Controls-Button-Secondary-Border, #00388F);\n    background: #F1F2F3 0% 0% no-repeat padding-box !important;\n    color: var(--Controls-Button-Secondary-Text-icon, #00388F);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 15px;\n  }\n\n  .tooltip-content {\n    width: 300;\n    height: 67.00012969970703;\n    angle: 0 deg;\n    opacity: 1;\n    border-width: 1px;\n    border-radius: 4px;\n    color: black;\n    top: 441px !important;\n    height: 66px;\n    background: var(--Controls-Fill, #FFFFFF);\n    box-shadow: 0px 2px 12px 0px #25303A0F;\n    box-shadow: 0px 2px 4px -1px #25303A0F;\n    box-shadow: 0px 2px 8px 0px #25303A1F;\n    @include respond-to('small') {\n        top: 30px !important;\n    }\n  }\n\n  i.tooltip-icon.tooltipActive:after {\n    background-color:  var(--Controls-Fill, #FFFFFF);\n    left: 0px;\n}\n\n.tooltip-zte {\n    top: 461px !important;\n    margin-right: 99px !important;\n    @include respond-to('small') {\n        top: 352px !important;\n        margin-right: 50px !important;\n    }\n}\n\n.tooltip-kme {\n    // top: 461px !important;\n    top: 551px !important;\n    margin-right: 99px !important;\n    @include respond-to('small') {\n        top: 352px !important;\n        margin-right: 50px !important;\n    }\n}\n\n.tooltipActive + div.helper-content.tooltipContent-kme {\n    width: 300px !important;\n    margin-left: 455px !important;\n    // top: 356px !important;\n    top: 444px !important;\n    @include respond-to('small') {\n        margin-left: 0px !important;\n        top: -100px !important;\n     }\n}\n\n\n\n@include respond-to('small') {\n    .fan-selection {\n        margin-left: -25px;\n        // margin-top: -30px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
